<script>
  import { Router, Route } from "svelte-routing";

  import Index1 from "./routes/Index.svelte";


  export let url = "";
</script>

<Router {url}>
    <Index1 />
</Router>
